import React from 'react';
import InfoContainerMD from '../../core/infoContainerMD';
import { districtsHeadings } from '../configs/districtsInfoConfig';
import ParentAccessPanel from './parentAccessPanel';


const DistrictInformationTab = ({data, handleOpen, updating, setUpdating}) => {
    return (
        <>
        <InfoContainerMD
            config={districtsHeadings}
            infoData={data}
            incidentData={true}
            handleOpen={handleOpen}
            updating={updating}
            setUpdating={setUpdating}
            type={"districts"}
        />
        <ParentAccessPanel data={data} />
        </>
    );
};

export default DistrictInformationTab;